"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LIB_LOAD_MAX_RETRIES = exports.DEFAULT_LIB_LOAD_TIMEOUT = exports.DEFAULT_LIB_LOAD_CHECK_INTERVAL = void 0;
const DEFAULT_LIB_LOAD_CHECK_INTERVAL = exports.DEFAULT_LIB_LOAD_CHECK_INTERVAL = 500;
const DEFAULT_LIB_LOAD_TIMEOUT = exports.DEFAULT_LIB_LOAD_TIMEOUT = 60_000;
const LIB_LOAD_MAX_RETRIES = exports.LIB_LOAD_MAX_RETRIES = DEFAULT_LIB_LOAD_TIMEOUT / DEFAULT_LIB_LOAD_CHECK_INTERVAL;